import { Link } from 'react-router-dom';

interface Match {
  id: string;
  homeTeam: string;
  awayTeam: string;
  homeLogo: string;
  awayLogo: string;
  league: string;
  category: string;
  startTime: string;
  status: string;
  homeOdds: number;
  drawOdds?: number;
  awayOdds: number;
  liveScore?: string;
  popularity: number;
  isHot: boolean;
  isLive: boolean;
}

interface MatchCardProps {
  match: Match;
}

export default function MatchCard({ match }: MatchCardProps) {
  const formatTime = (timeStr: string) => {
    const date = new Date(timeStr);
    const month = date.getMonth() + 1;
    const day = date.getDate();
    const hours = date.getHours().toString().padStart(2, '0');
    const mins = date.getMinutes().toString().padStart(2, '0');
    return `${month}月${day}日 ${hours}:${mins}`;
  };

  return (
    <div className="bg-background-50 rounded-lg border border-background-200/70 p-4 hover:border-primary-300 transition-all duration-200 cursor-pointer">
      <div className="flex items-center justify-between mb-3">
        <div className="flex items-center gap-2">
          <span className="text-xs px-2 py-0.5 bg-secondary-100 text-secondary-900 rounded-full font-medium whitespace-nowrap">
            {match.league}
          </span>
          {match.isHot && (
            <span className="text-xs px-2 py-0.5 bg-accent-100 text-accent-900 rounded-full font-medium flex items-center gap-1 whitespace-nowrap">
              <i className="ri-fire-line text-xs"></i>
              热门
            </span>
          )}
          {match.isLive && (
            <span className="text-xs px-2 py-0.5 bg-red-100 text-red-700 rounded-full font-medium flex items-center gap-1 whitespace-nowrap">
              <span className="w-1.5 h-1.5 bg-red-500 rounded-full animate-pulse"></span>
              直播中
            </span>
          )}
        </div>
        <span className="text-xs text-foreground-500 whitespace-nowrap">{formatTime(match.startTime)}</span>
      </div>

      <div className="flex items-center justify-between mb-4">
        <div className="flex flex-col items-center gap-1 flex-1">
          <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center overflow-hidden">
            <img src={match.homeLogo} alt={match.homeTeam} className="w-10 h-10 object-contain" loading="lazy" />
          </div>
          <span className="text-sm font-medium text-foreground-950 text-center whitespace-nowrap">{match.homeTeam}</span>
        </div>

        <div className="flex flex-col items-center px-3">
          {match.isLive && match.liveScore ? (
            <span className="text-xl font-bold text-primary-500 whitespace-nowrap">{match.liveScore}</span>
          ) : (
            <span className="text-xs text-foreground-400 whitespace-nowrap">VS</span>
          )}
        </div>

        <div className="flex flex-col items-center gap-1 flex-1">
          <div className="w-12 h-12 rounded-full bg-background-100 flex items-center justify-center overflow-hidden">
            <img src={match.awayLogo} alt={match.awayTeam} className="w-10 h-10 object-contain" loading="lazy" />
          </div>
          <span className="text-sm font-medium text-foreground-950 text-center whitespace-nowrap">{match.awayTeam}</span>
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="flex-1 text-center py-2 rounded-md bg-background-100 hover:bg-primary-50 transition-colors">
          <span className="text-xs text-foreground-500">主胜</span>
          <p className="text-sm font-bold text-primary-500 mt-0.5">{match.homeOdds.toFixed(2)}</p>
        </div>
        {match.drawOdds && (
          <div className="flex-1 text-center py-2 rounded-md bg-background-100 hover:bg-primary-50 transition-colors">
            <span className="text-xs text-foreground-500">平局</span>
            <p className="text-sm font-bold text-foreground-700 mt-0.5">{match.drawOdds.toFixed(2)}</p>
          </div>
        )}
        <div className="flex-1 text-center py-2 rounded-md bg-background-100 hover:bg-primary-50 transition-colors">
          <span className="text-xs text-foreground-500">客胜</span>
          <p className="text-sm font-bold text-foreground-700 mt-0.5">{match.awayOdds.toFixed(2)}</p>
        </div>
      </div>
    </div>
  );
}